<p>view-plan works!</p>
